import { createServer } from 'miragejs';
import mockMood from './mocks/mockMood.json';
import mockFeed from './mocks/mockFeed.json';
import mockUpdateMood from './mocks/mockUpdateMood.json';
import mockUser from './mocks/mockUser.json';
import mockLeaderboard from './mocks/mockLeaderboard.json';
import { APIS } from '../constants/apis';

export const createMockServer = () => {
  const server = createServer();

  server.get(`${APIS.getUser}${mockUser.userId}`, mockUser);

  server.get(`${APIS.getMood}${mockUser.userId}`, mockMood);
  server.patch(`${APIS.updateMood}${mockUser.userId}`, mockUpdateMood);

  server.get(APIS.getFeed, mockFeed);
  server.delete(`${APIS.deletePost}${mockFeed[0].id}`, { status: 201 });
  server.post(APIS.savePost, { status: 201 });

  server.get(APIS.getLeaderboard, mockLeaderboard);

  server.post(APIS.saveActivity, { status: 201 });
  server.delete(
    `${APIS.deleteActivity}${mockUser.activities[0].id}_${mockUser.userIid}`,
    { status: 201 },
  );

  return server;
};
